import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { LocalizedText } from '@mews/framework';
import { CellContext, Divider, DropdownItem, Grid, Selected, SelectElement, Typography } from '@optimus-web/core';
import { values } from '@mews/fp';
import { CheckInConfigurationType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { DocumentsTableDataItem } from './types';

const isCheckInConfigurationType = (value: Selected): value is CheckInConfigurationType =>
    pipe(
        CheckInConfigurationType,
        values,
        array.findFirst((enumValue) => enumValue === value),
        option.isSome
    );

const defaultDocumentType = 'defaultDocument';

export const DocumentTypeOptions = (props: CellContext<DocumentsTableDataItem, unknown>) => {
    const current = props.row.original;
    const { setDocumentType, type } = current;

    const handleActionClick = (_e: React.ChangeEvent, value: Selected) => {
        if (isCheckInConfigurationType(value)) {
            setDocumentType(value);
        } else {
            setDocumentType(null);
        }
    };

    return (
        <SelectElement
            onChange={handleActionClick}
            selected={type != null ? type : defaultDocumentType}
            name="documentTypeOptions"
        >
            <DropdownItem
                label={<LocalizedText textKey={TextKey.DefaultDocument} />}
                key={defaultDocumentType}
                value={defaultDocumentType}
            />
            <DropdownItem
                label={
                    <Grid>
                        <Divider direction="horizontal" />
                        <Typography textStyle="bodySmallStrong" as="div">
                            <LocalizedText textKey={TextKey.CheckInFieldsMultipleDocumentsDescription} />
                        </Typography>
                    </Grid>
                }
                disabled
            />
            <DropdownItem
                label={<LocalizedText textKey={TextKey.IdCardOrPassportDriversLicense} />}
                key={CheckInConfigurationType.PassportOrIdentityCardOrDriversLicense}
                value={CheckInConfigurationType.PassportOrIdentityCardOrDriversLicense}
            />
            <DropdownItem
                label={<LocalizedText textKey={TextKey.IdCardOrPassport} />}
                key={CheckInConfigurationType.PassportOrIdentityCard}
                value={CheckInConfigurationType.PassportOrIdentityCard}
            />
            <DropdownItem
                label={
                    <Grid>
                        <Divider direction="horizontal" />
                        <Typography textStyle="bodySmallStrong" as="div">
                            <LocalizedText textKey={TextKey.CheckInFieldsIndividualDocumentsDescription} />
                        </Typography>
                    </Grid>
                }
                disabled
            />
            <DropdownItem
                label={<LocalizedText textKey={TextKey.Passport} />}
                key={CheckInConfigurationType.DirectPassport}
                value={CheckInConfigurationType.DirectPassport}
            />
            <DropdownItem
                label={<LocalizedText textKey={TextKey.IdCard} />}
                key={CheckInConfigurationType.DirectIdentityCard}
                value={CheckInConfigurationType.DirectIdentityCard}
            />
            <DropdownItem
                label={<LocalizedText textKey={TextKey.DriversLicense} />}
                key={CheckInConfigurationType.DirectDriversLicense}
                value={CheckInConfigurationType.DirectDriversLicense}
            />
        </SelectElement>
    );
};
